module.exports = __webpack_public_path__ + "static/media/rodinnydom23.735892b2.jpg";